import React, { useEffect, useState, useRef } from 'react';
import { ORDER_TYPE_DELIVERY, NO_SLOT_AVAILABLE_MESSAGE } from '../../../constants';
import { getMaximumPreparationTime, getOrderTimes } from '../CartModal.services';
import moment from 'moment';
import { updateOrderTime, showMessageModal } from '../../../redux/actions';
import ReusableDatePicker from '../../ReusableDatePicker/ReusableDatePicker'
import { useAppDispatch, useAppSelector } from '../../../redux/hook';
import { convertHoursToDays } from '../../../utils';
import CustomDayPickerInput from './CustomDayPickerInput';
import _ from 'lodash';
export default function OrderTime({
  day,
  setDateState,
  setLoading,
  isValidDate,
  hourSelectValue,
  selectTime,
}) {
  const dispatch = useAppDispatch();

  const { orderTime } = useAppSelector((state) => state.orderReducer);

  const { closed, openHours, specialHours } = useAppSelector((state) => state.shopReducer);

  const { commande, orderType } = useAppSelector(
    (state) => state.pendingOrderReducer
  );

  const [orderTimes, setOrderTimes] = useState([]);
  const maximumPreparationTime = getMaximumPreparationTime(commande);

   const title = orderType === ORDER_TYPE_DELIVERY ? 'Heure de livraison' : 'Heure de récupération';

  const disabledTime = !orderTimes?.length || (orderTimes[0]?.disabled && !selectTime) || !!closed;
  const prevOpenHours = useRef(openHours);
  const prevSpecialHours = useRef(specialHours);

   useEffect(() => {
    const openHoursChanged = !_.isEqual(prevOpenHours.current, openHours);
    const specialHoursChanged = !_.isEqual(prevSpecialHours.current, specialHours);
    if (openHoursChanged || specialHoursChanged) {
        (async () => {
        setDateState({ day: moment(), hourSelectValue: 0, selectTime: false, isValidDate: true });
       })();
      prevOpenHours.current = openHours;
      prevSpecialHours.current = specialHours;

    }
  }, [openHours, specialHours]);

useEffect(() => {
  const fetchOrderTimes = async () => {
    setLoading(true);
    const orderTimes = await getOrderTimes(day);
    setOrderTimes(orderTimes);
    dispatch(updateOrderTime(!!closed || !orderTimes?.length ? null : orderTimes[0] ?? null));
    setLoading(false);
  };

    fetchOrderTimes();

}, [day]);

  return (
    <div className='mb-2'>
      <p className='text-muted mb-1 label'>{title}</p>
      <div className='row pb-2'>
        <div className='col-6 pr-3'>
          <p className='mb-1 label'>Jour: </p>
      <ReusableDatePicker
        selected={closed ? null : day.toDate()}
        setDateState={setDateState}
        closed={closed}
        customInput={
          <CustomDayPickerInput
            isValidDate={isValidDate}
            orderTime={orderTime?.value}
            closed={closed}
          />
        }
        />
          {!isValidDate && !orderTime && (
            <div className='invalid-feedback-block'>
              Veuillez choisir une date{' '}
            </div>
          )}
        </div>
        <div className='col-6 pl-3'>
          <p className='mb-1 label'>Heure: </p>
          <select
            disabled={!!closed}
            className={`custom-select ${!isValidDate && orderTime?.disabled &&
              'is-invalid'
              } dark-modal`}
            onClick={!orderTimes?.length ? () => dispatch(showMessageModal(NO_SLOT_AVAILABLE_MESSAGE)) : null}
            onChange={(e) => {
              const index = e.target.value;
              if (!orderTimes[index]?.disabled){
              dispatch(updateOrderTime(orderTimes[index]));
               setDateState({
                hourSelectValue: index,
                selectTime: true,
                isValidDate: true,
                });
              }
            }}
             value={disabledTime || orderTimes[hourSelectValue]?.disabled ? '' : hourSelectValue}
          >
            <option
              value=''
              className='empty-option'
            ></option>
            {orderTimes?.map((orderTime, index) => {
              const { value } = orderTime;
              return (
                <option
                  disabled={orderTime.disabled}
                  value={index}
                >
                  {value}
                </option>
              );
            })}
          </select>
          {!isValidDate && orderTime?.disabled && (
            <div className='invalid-feedback-block'>
              Veuillez choisir une heure{' '}
            </div>
          )}
        </div>
      </div>
      {maximumPreparationTime > 0 && (
        <p className='text-warning mb-0'>
          {`Votre panier nécessite au moins ${convertHoursToDays(maximumPreparationTime) > 0
            ? `${convertHoursToDays(maximumPreparationTime)} jour(s)`
            : `${maximumPreparationTime} heure(s)`
            } de préparation`}
        </p>
      )}
    </div>
  );
}
